/*
 *
 * ProjectDetail
 *
 */

import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import Dropzone from "react-dropzone";
import Compressor from "compressorjs";
import { push } from "connected-react-router";

import { Table, Icon, SelectableTabs, ContentWrapper, Editor } from "components";
import { Checkbox, Row, Col, Input, InputNumber, Switch } from "antd";

import { SketchPicker } from "react-color";

import { setLoader, setTitle, delayedDispatch, setBreadcrumb, updateCrumb } from "store/actions";
import { API, Endpoints } from "utils/api";
import { toast } from "utils/utils";

import Strings from "utils/strings";
import placeholder from "assets/images/placeholders/image.jpg";
import "./styles.scss";
import TextArea from "antd/lib/input/TextArea";

export class ProjectDetail extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            project: {},
            filesToDelete: [],
            selectedTab: "general",
            hasUnsavedFields: false,
            language: props.user?.language || "en",
            review: {
                image: null,
                name: "",
                position: {
                    en: "",
                    pt: "",
                    es: "",
                },
                workQuality: 0,
                delivery: 0,
                response: 0,
                satisfaction: 0,
                totalCost: 0,
                referral: false,
                review: {
                    en: "",
                    pt: "",
                    es: "",
                },
            },
        };
    }

    componentDidMount() {
        const { dispatch, match } = this.props;

        dispatch(setTitle(Strings.projects.project));

        delayedDispatch(
            setBreadcrumb(() => {
                return {
                    locations: [
                        {
                            text: Strings.sidebar.projects,
                            route: "/projects",
                            icon: "tarefa",
                        },
                        {
                            text:
                                match?.params?.id === "new" &&
                                (!this.state.project.name || this.state.project.name === "")
                                    ? match.params.id
                                    : this.state.project.name,
                        },
                    ],
                    actions: [
                        {
                            type: "switch",
                            small: {
                                switch: true,
                                text: true,
                            },
                            text: Strings.projects.active,
                            value: this.state.project.active,
                            onClick: () => {
                                this.toggleActive();
                            },
                        },
                        {
                            type: "language",
                            value: this.state.language,
                            onChange: (language: any) => this.setState({ language }),
                        },
                        {
                            type: "button",
                            onClick: () => this.saveProject(),
                            text: Strings.generic.save,
                            disabled: !this.state.hasUnsavedFields,
                            isSave: true,
                        },
                    ],
                };
            })
        );
        if (match?.params?.id !== "new") this.getProject();
    }

    componentDidUpdate() {
        const { dispatch } = this.props;
        dispatch(updateCrumb());
    }

    async getProject() {
        const { dispatch, match } = this.props;

        dispatch(setLoader(true));

        try {
            const response = await API.get({
                url: Endpoints.uriProjects(match.params.id),
            });
            if (response.ok) {
                this.setState({
                    project: response.data.results || {},
                });
            }
        } catch (err) {
            const errorMessage = (err as any)?.message;
            toast.error(errorMessage);
        }

        dispatch(setLoader(false));
    }

    sendReview = async (lang: any) => {
        const { dispatch, match } = this.props;

        dispatch(setLoader(true));

        try {
            const url = `${Endpoints.uriProjects(match.params.id)}/review/${lang}`;
            const response = await API.patch({
                url,
            });
            if (response.ok) {
                toast.success("Review sent with sucess");
            }
        } catch (err) {
            const errorMessage = (err as any)?.message;
            toast.error(errorMessage);
        }

        dispatch(setLoader(false));
    };

    async saveProject() {
        const { dispatch, match } = this.props;
        const { project, filesToDelete } = this.state;

        const body = new FormData();
        // GENERAL
        body.append("active", project.active || false);

        if (typeof project.categoryImage === "object" && project.categoryImage !== null)
            body.append("categoryImage", project.categoryImage.file);
        else body.append("categoryImage", project.categoryImage);

        if (typeof project.mainImage === "object" && project.mainImage !== null)
            body.append("mainImage", project.mainImage.file);
        else body.append("mainImage", project.mainImage);

        if (typeof project.icon === "object" && project.icon !== null) body.append("icon", project.icon.file);
        else body.append("icon", project.icon);

        body.append("name", project.name || "");
        body.append("seoDescription", project.seoDescription || "");
        body.append("keywords", project.keywords || "");
        body.append("link", project.link || "");
        body.append("country", JSON.stringify(project.country || {}));
        body.append("countryCode", project.countryCode || "");
        body.append("linkWeb", project.linkWeb || "");
        body.append("linkGooglePlay", project.linkGooglePlay || "");
        body.append("linkAppStore", project.linkAppStore || "");
        body.append("linkLinkedIn", project.linkLinkedIn || "");
        body.append("smallDescription", JSON.stringify(project.smallDescription || {}));
        body.append("numbersSections", JSON.stringify(project.numbersSections || []));
        body.append("techSection", JSON.stringify(project.techSection || {}));

        // REVIEW
        if (project.review && typeof project.review.image === "object" && project.review.image !== null) {
            body.append("ownerImage", project.review.image.file);
            const review = {
                ...project.review,
                image: null,
            };
            body.append("review", JSON.stringify(review || {}));
        } else body.append("review", JSON.stringify(project.review || {}));

        // SECTIONS
        let auxSections = [];
        if (project.sections && project.sections.length >= 1) {
            for (let i = 0; i < project.sections.length; i++) {
                const image = project.sections[i].sectionImage;

                if (image?.file) {
                    body.append(`section_${i + 1}`, image.file);
                    delete project.sections[i].sectionImage;
                }

                const section = {
                    ...project.sections[i],
                    order: i + 1,
                };

                if (!image?.file) {
                    section.sectionImage = image;
                }

                auxSections.push(section);
            }
        }

        body.append("sections", JSON.stringify(auxSections || []));

        // FILES TO DELETE
        if (filesToDelete.length > 0) body.append("filesToDelete", JSON.stringify(filesToDelete || []));

        dispatch(setLoader(true));

        try {
            const response =
                match?.params?.id === "new"
                    ? await API.post({
                          url: Endpoints.uriProjects(),
                          data: body,
                      })
                    : await API.put({
                          url: Endpoints.uriProjects(match.params.id),
                          data: body,
                      });
            if (response.ok) {
                if (match?.params?.id === "new") dispatch(push(`/projects/${response.data.results._id}`));
                else
                    this.setState({
                        project: response.data.results,
                        filesToDelete: [],
                        hasUnsavedFields: false,
                    });
            }
        } catch (err) {
            const errorMessage = (err as any)?.message;
            toast.error(errorMessage);
        }

        dispatch(setLoader(false));
    }

    array_move(arr: any, old_index: any, new_index: any) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        //return arr;
    }

    getBase64 = (file: any) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    onDrop = (files: any, field: string) => {
        if (!field) return;

        try {
            const file = files[files.length - 1];

            new Compressor(file, {
                mimeType: "image/png",
                success: (result: any) => {
                    this.getBase64(result).then((res) => {
                        let updateState = {
                            project: {
                                ...this.state.project,
                                [field]: { file: result, preview: res },
                            },
                            hasUnsavedFields: true,
                        };

                        if (field === "ownerImage") {
                            updateState.project.review.image = { file: result, preview: res };
                        } else updateState.project[field] = { file: result, preview: res };
                        this.setState((state: any) => updateState);
                    });
                },
            });
        } catch (err) {
            toast.warning(Strings.errors.notSupportedFile);
        }
    };

    toggleActive = () => {
        this.setState({
            project: { ...this.state.project, active: !this.state.project.active },
            hasUnsavedFields: true,
        });
    };

    toggleWIP() {
        this.setState({
            project: {
                ...this.state.project,
                workInProgress: !this.state.project.workInProgress,
            },
            hasUnsavedFields: true,
        });
    }

    toggleTBR() {
        this.setState({
            project: {
                ...this.state.project,
                toBeReleased: !this.state.project.toBeReleased,
            },
            hasUnsavedFields: true,
        });
    }

    renderColorPicker(
        color: any,
        displayColorPicker: any,
        handleClick: any,
        handleClose: any,
        handlePickerChange: any,
        handleInputChange: any
    ) {
        return (
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div
                    style={{
                        padding: "5px",
                        marginRight: "6px",
                        background: "#fff",
                        borderRadius: "4px",
                        border: "1px solid #d9d9d9",
                        display: "inline-block",
                        cursor: "pointer",
                    }}
                    onClick={handleClick}
                >
                    <div
                        style={{
                            width: "30px",
                            height: "100%",
                            borderRadius: "4px",
                            background: color,
                        }}
                    />
                </div>
                {displayColorPicker ? (
                    <div
                        style={{
                            position: "absolute",
                            zIndex: 2,
                        }}
                    >
                        <div
                            style={{
                                position: "fixed",
                                top: "0px",
                                right: "0px",
                                bottom: "0px",
                                left: "0px",
                            }}
                            onClick={handleClose}
                        />
                        <SketchPicker color={color} onChange={handlePickerChange} />
                    </div>
                ) : null}
                <Input
                    placeholder={Strings.projects.name}
                    defaultValue={color || ""}
                    value={color || ""}
                    onChange={handleInputChange}
                />
            </div>
        );
    }

    renderGeneral() {
        const { project, language } = this.state;
        return (
            <div>
                <ContentWrapper>
                    <Row gutter={[24, 24]}>
                        <Col xs={24} lg={8}>
                            <label className="SingleLabel __required">{Strings.projects.icon}</label>
                            <div className="ImageContainer">
                                <div className="Image">
                                    <img
                                        alt={Strings.fields.image}
                                        src={
                                            project.icon !== null && typeof project.icon === "object"
                                                ? project.icon.preview
                                                : project.icon && project.icon !== "undefined"
                                                ? project.icon
                                                : placeholder
                                        }
                                    />
                                    <div className="ImageOverlay">
                                        <Dropzone
                                            accept="image/jpg, image/jpeg, image/png"
                                            className="ImageOverlayOption"
                                            onDrop={(files) => this.onDrop(files, "icon")}
                                        >
                                            <Icon name="pencil-outline" />
                                        </Dropzone>
                                        <div
                                            className={`ImageOverlayOption${
                                                Boolean(project.icon) ? "" : " __disabled"
                                            }`}
                                            onClick={() => {
                                                const deleteArray = [...this.state.filesToDelete];
                                                if (project.icon && !project.icon.file) deleteArray.push(project.icon);

                                                this.setState({
                                                    project: {
                                                        ...project,
                                                        icon: null,
                                                    },
                                                    filesToDelete: deleteArray,
                                                    hasUnsavedFields: true,
                                                });
                                            }}
                                        >
                                            <Icon name="trash" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={24} lg={8}>
                            <label className="SingleLabel __required">{Strings.projects.categoryImage}</label>
                            <div className="ImageContainer">
                                <div className="Image">
                                    <img
                                        alt={Strings.fields.image}
                                        src={
                                            project.categoryImage !== null && typeof project.categoryImage === "object"
                                                ? project.categoryImage.preview
                                                : project.categoryImage && project.categoryImage !== "undefined"
                                                ? project.categoryImage
                                                : placeholder
                                        }
                                    />
                                    <div className="ImageOverlay">
                                        <Dropzone
                                            accept="image/jpg, image/jpeg, image/png"
                                            className="ImageOverlayOption"
                                            onDrop={(files) => this.onDrop(files, "categoryImage")}
                                        >
                                            <Icon name="pencil-outline" />
                                        </Dropzone>
                                        <div
                                            className={`ImageOverlayOption${
                                                Boolean(project.categoryImage) ? "" : " __disabled"
                                            }`}
                                            onClick={() => {
                                                const deleteArray = [...this.state.filesToDelete];
                                                if (project.categoryImage && !project.categoryImage.file)
                                                    deleteArray.push(project.categoryImage);

                                                this.setState({
                                                    project: {
                                                        ...project,
                                                        categoryImage: null,
                                                    },
                                                    filesToDelete: deleteArray,
                                                    hasUnsavedFields: true,
                                                });
                                            }}
                                        >
                                            <Icon name="trash" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={24} lg={8}>
                            <label className="SingleLabel __required">{Strings.projects.mainImage}</label>
                            <div className="ImageContainer">
                                <div className="Image">
                                    <img
                                        alt={Strings.fields.image}
                                        src={
                                            project.mainImage !== null && typeof project.mainImage === "object"
                                                ? project.mainImage.preview
                                                : project.mainImage && project.mainImage !== "undefined"
                                                ? project.mainImage
                                                : placeholder
                                        }
                                    />
                                    <div className="ImageOverlay">
                                        <Dropzone
                                            accept="image/jpg, image/jpeg, image/png"
                                            className="ImageOverlayOption"
                                            onDrop={(files) => this.onDrop(files, "mainImage")}
                                        >
                                            <Icon name="pencil-outline" />
                                        </Dropzone>
                                        <div
                                            className={`ImageOverlayOption${
                                                Boolean(project.mainImage) ? "" : " __disabled"
                                            }`}
                                            onClick={() => {
                                                const deleteArray = [...this.state.filesToDelete];
                                                if (project.mainImage && !project.mainImage.file)
                                                    deleteArray.push(project.mainImage);

                                                this.setState({
                                                    project: {
                                                        ...project,
                                                        mainImage: null,
                                                    },
                                                    filesToDelete: deleteArray,
                                                    hasUnsavedFields: true,
                                                });
                                            }}
                                        >
                                            <Icon name="trash" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={[24, 24]}>
                        <Col xs={24} lg={6}>
                            <label className="SingleLabel __required">{Strings.projects.name}</label>
                            <Input
                                placeholder={Strings.projects.name}
                                defaultValue={project.name || ""}
                                value={project.name || ""}
                                onChange={(e) => {
                                    this.setState({
                                        project: { ...project, name: e.target.value },
                                        hasUnsavedFields: true,
                                    });
                                }}
                            />
                        </Col>
                        <Col xs={24} lg={6}>
                            <label className="SingleLabel __required">{Strings.projects.link}</label>
                            <Input
                                placeholder={"Link"}
                                defaultValue={project.link ? project.link : ""}
                                value={project.link ? project.link : ""}
                                onChange={(e) => {
                                    this.setState({
                                        project: {
                                            ...project,
                                            link: e.target.value,
                                        },
                                        hasUnsavedFields: true,
                                    });
                                }}
                            />
                        </Col>
                        <Col xs={24} lg={6}>
                            <label className="SingleLabel __required">{Strings.projects.country}</label>
                            <Input
                                placeholder={Strings.projects.country}
                                defaultValue={project.country ? project.country[language] : ""}
                                value={project.country ? project.country[language] : ""}
                                onChange={(e) => {
                                    this.setState({
                                        project: {
                                            ...project,
                                            country: {
                                                ...project.country,
                                                [language]: e.target.value,
                                            },
                                        },
                                        hasUnsavedFields: true,
                                    });
                                }}
                            />
                        </Col>
                        <Col xs={24} lg={6}>
                            <label className="SingleLabel __required">{Strings.projects.countryCode}</label>
                            <Input
                                placeholder={Strings.projects.countryCode}
                                defaultValue={project.countryCode ? project.countryCode : ""}
                                value={project.countryCode ? project.countryCode : ""}
                                onChange={(e) => {
                                    this.setState({
                                        project: {
                                            ...project,
                                            countryCode: e.target.value,
                                        },
                                        hasUnsavedFields: true,
                                    });
                                }}
                            />
                        </Col>
                        <Col xs={24} lg={24}>
                            <label className="SingleLabel __required">{Strings.fields.seoDescription}</label>
                            <TextArea
                                placeholder={Strings.fields.seoDescription}
                                defaultValue={project.seoDescription || ""}
                                value={project.seoDescription || ""}
                                rows={4}
                                onChange={(e) => {
                                    this.setState({
                                        project: { ...project, seoDescription: e.target.value },
                                        hasUnsavedFields: true,
                                    });
                                }}
                            />
                        </Col>
                        <Col xs={24} lg={24}>
                            <label className="SingleLabel __required">{Strings.fields.keywords}</label>
                            <TextArea
                                placeholder={Strings.fields.keywords}
                                defaultValue={project.keywords || ""}
                                value={project.keywords || ""}
                                rows={4}
                                onChange={(e) => {
                                    this.setState({
                                        project: { ...project, keywords: e.target.value },
                                        hasUnsavedFields: true,
                                    });
                                }}
                            />
                        </Col>
                    </Row>
                    <Row gutter={[24, 24]}>
                        <Col xs={24} lg={24}>
                            <label className="SingleLabel __required">{Strings.projects.description}</label>
                            <Editor
                                extraData={language}
                                btnBlacklist={["source"]}
                                value={project.smallDescription ? project.smallDescription[language] : ""}
                                onChange={(data: any) => {
                                    this.setState({
                                        project: {
                                            ...project,
                                            smallDescription: {
                                                ...project.smallDescription,
                                                [language]: data,
                                            },
                                        },
                                        hasUnsavedFields: true,
                                    });
                                }}
                            />
                        </Col>
                    </Row>
                    <Row gutter={[24, 24]}>
                        <Col xs={24} lg={6}>
                            <label className="SingleLabel">{Strings.projects.linkAppStore}</label>
                            <Input
                                placeholder={Strings.placeholders.link}
                                defaultValue={project.linkAppStore || ""}
                                value={project.linkAppStore || ""}
                                onChange={(e) => {
                                    this.setState({
                                        project: { ...project, linkAppStore: e.target.value },
                                        hasUnsavedFields: true,
                                    });
                                }}
                            />
                        </Col>
                        <Col xs={24} lg={6}>
                            <label className="SingleLabel">{Strings.projects.linkGooglePlay}</label>
                            <Input
                                placeholder={Strings.placeholders.link}
                                defaultValue={project.linkGooglePlay || ""}
                                value={project.linkGooglePlay || ""}
                                onChange={(e) => {
                                    this.setState({
                                        project: { ...project, linkGooglePlay: e.target.value },
                                        hasUnsavedFields: true,
                                    });
                                }}
                            />
                        </Col>
                        <Col xs={24} lg={6}>
                            <label className="SingleLabel">{Strings.projects.linkWeb}</label>
                            <Input
                                placeholder={Strings.placeholders.link}
                                defaultValue={project.linkWeb || ""}
                                value={project.linkWeb || ""}
                                onChange={(e) => {
                                    this.setState({
                                        project: { ...project, linkWeb: e.target.value },
                                        hasUnsavedFields: true,
                                    });
                                }}
                            />
                        </Col>
                        <Col xs={24} lg={6}>
                            <label className="SingleLabel">{Strings.projects.linkLinkedIn}</label>
                            <Input
                                placeholder={Strings.placeholders.link}
                                defaultValue={project.linkLinkedIn || ""}
                                value={project.linkLinkedIn || ""}
                                onChange={(e) => {
                                    this.setState({
                                        project: { ...project, linkLinkedIn: e.target.value },
                                        hasUnsavedFields: true,
                                    });
                                }}
                            />
                        </Col>
                    </Row>
                </ContentWrapper>
            </div>
        );
    }

    renderTechSection(row: any) {
        const { project, language } = this.state;

        return (
            <ContentWrapper>
                <Row gutter={[24, 24]}>
                    <Col xs={24} lg={18}>
                        <label className="SingleLabel __required">{Strings.projects.technologies}</label>
                        <Input
                            placeholder={"Section Name"}
                            defaultValue={
                                project.techSection.technologies[row.id].title
                                    ? project.techSection.technologies[row.id].title[language]
                                    : ""
                            }
                            value={
                                project.techSection.technologies[row.id].title
                                    ? project.techSection.technologies[row.id].title[language]
                                    : ""
                            }
                            onChange={(e) => {
                                this.setState(
                                    {
                                        project: {
                                            ...project,
                                            techSection: {
                                                ...project.techSection,
                                                technologies: project.techSection.technologies.map(
                                                    (element: any, index: any) => {
                                                        if (index === row.index)
                                                            return {
                                                                ...element,
                                                                title: {
                                                                    ...element.title,
                                                                    [language]: e.target.value,
                                                                },
                                                            };
                                                        return element;
                                                    }
                                                ),
                                            },
                                        },
                                        hasUnsavedFields: true,
                                    },
                                    () => {
                                        row.toggleRowExpanded(true);
                                    }
                                );
                            }}
                        />
                    </Col>
                    <Col xs={12} lg={6}>
                        <label className="SingleLabel __required">{Strings.projects.order}</label>
                        <InputNumber
                            style={{ width: "100%" }}
                            min={1}
                            max={project.techSection.technologies.length}
                            defaultValue={row.id + 1}
                            value={row.id + 1}
                            onChange={(value: any) => {
                                if (project.techSection.technologies.length > 1) {
                                    this.array_move(project.techSection.technologies, row.id, value - 1);
                                }
                                this.setState({
                                    project: {
                                        ...project,
                                        techSection: {
                                            ...project.techSection,
                                            technologies: project.techSection.technologies.map(
                                                (element: any, index: any) => {
                                                    if (index === row.index)
                                                        return {
                                                            ...element,
                                                            order: value - 1,
                                                        };

                                                    return element;
                                                }
                                            ),
                                        },
                                    },
                                    hasUnsavedFields: true,
                                });
                            }}
                        />
                    </Col>
                    <Col xs={24} lg={24}>
                        <label className="SingleLabel __required">{Strings.projects.technologies}</label>
                        <Checkbox.Group
                            style={{ width: "100%" }}
                            options={[
                                "ReactJS",
                                "Vite",
                                "Redux",
                                "AngularJS",
                                "Vue",
                                "React Native",
                                "Expo",
                                "Flutter",
                                "Java",
                                "NodeJS",
                                "Python",
                                "MongoDB",
                                "PostgreSQL",
                                "Mendix",
                                "OutSystems",
                            ]}
                            defaultValue={[""]}
                            value={
                                project.techSection.technologies[row.id].stacks
                                    ? project.techSection.technologies[row.id].stacks
                                    : [""]
                            }
                            onChange={(checkedValues) => {
                                this.setState(
                                    {
                                        project: {
                                            ...project,
                                            techSection: {
                                                ...project.techSection,
                                                technologies: project.techSection.technologies.map(
                                                    (element: any, index: any) => {
                                                        if (index === row.index)
                                                            return {
                                                                ...element,
                                                                stacks: checkedValues,
                                                            };
                                                        return element;
                                                    }
                                                ),
                                            },
                                        },
                                        hasUnsavedFields: true,
                                    },
                                    () => {
                                        row.toggleRowExpanded(true);
                                    }
                                );
                            }}
                        />
                    </Col>
                </Row>
            </ContentWrapper>
        );
    }

    renderNumberSection(row: any) {
        const { project, language } = this.state;

        return (
            <ContentWrapper>
                <Row gutter={[24, 24]}>
                    <Col xs={24} lg={18}>
                        <label className="SingleLabel __required">{Strings.projects.numbers}</label>
                        <Input
                            placeholder={"Section Name"}
                            defaultValue={
                                project.numbersSections[row.id].title
                                    ? project.numbersSections[row.id].title[language]
                                    : ""
                            }
                            value={
                                project.numbersSections[row.id].title
                                    ? project.numbersSections[row.id].title[language]
                                    : ""
                            }
                            onChange={(e) => {
                                this.setState(
                                    {
                                        project: {
                                            ...project,
                                            numbersSections: project.numbersSections.map((element: any, index: any) => {
                                                if (index === row.index)
                                                    return {
                                                        ...element,
                                                        title: {
                                                            ...element.title,
                                                            [language]: e.target.value,
                                                        },
                                                    };
                                                return element;
                                            }),
                                        },
                                        hasUnsavedFields: true,
                                    },
                                    () => {
                                        row.toggleRowExpanded(true);
                                    }
                                );
                            }}
                        />
                    </Col>
                    <Col xs={12} lg={6}>
                        <label className="SingleLabel __required">{Strings.projects.order}</label>
                        <InputNumber
                            style={{ width: "100%" }}
                            min={1}
                            max={project.numbersSections.length}
                            defaultValue={row.id + 1}
                            value={row.id + 1}
                            onChange={(value: any) => {
                                if (project.numbersSections.length > 1) {
                                    this.array_move(project.numbersSections, row.id, value - 1);
                                }
                                this.setState({
                                    project: {
                                        ...project,
                                        numbersSections: project.numbersSections.map((element: any, index: any) => {
                                            if (index === row.index)
                                                return {
                                                    ...element,
                                                    order: value - 1,
                                                };

                                            return element;
                                        }),
                                    },
                                    hasUnsavedFields: true,
                                });
                            }}
                        />
                    </Col>
                    <Col xs={24} lg={24}>
                        <label className="SingleLabel __required">{Strings.projects.subtitle}</label>
                        <Input
                            placeholder={"Section Name"}
                            defaultValue={
                                project.numbersSections[row.id].value ? project.numbersSections[row.id].value : ""
                            }
                            value={project.numbersSections[row.id].value ? project.numbersSections[row.id].value : ""}
                            onChange={(e) => {
                                this.setState(
                                    {
                                        project: {
                                            ...project,
                                            numbersSections: project.numbersSections.map((element: any, index: any) => {
                                                if (index === row.index)
                                                    return {
                                                        ...element,
                                                        value: e.target.value,
                                                    };
                                                return element;
                                            }),
                                        },
                                        hasUnsavedFields: true,
                                    },
                                    () => {
                                        row.toggleRowExpanded(true);
                                    }
                                );
                            }}
                        />
                    </Col>
                </Row>
            </ContentWrapper>
        );
    }

    renderSection(row: any) {
        const { project, language } = this.state;

        return (
            <ContentWrapper>
                <ContentWrapper>
                    <Row gutter={[24, 24]}>
                        <Col xs={24} lg={8}>
                            <label className="SingleLabel __required">{Strings.projects.sectionImage}</label>
                            <div className="ImageContainer" style={{ maxHeight: "210px" }}>
                                <div className="Image">
                                    <img
                                        alt={Strings.projects.sectionImage}
                                        src={
                                            project.sections[row.id].sectionImage !== null &&
                                            typeof project.sections[row.id].sectionImage === "object"
                                                ? project.sections[row.id].sectionImage.preview
                                                : project.sections[row.id].sectionImage &&
                                                  project.sections[row.id].sectionImage !== "undefined"
                                                ? project.sections[row.id].sectionImage
                                                : placeholder
                                        }
                                    />
                                    <div className="ImageOverlay">
                                        <Dropzone
                                            accept="image/jpg, image/jpeg, image/png"
                                            className="ImageOverlayOption"
                                            onDrop={(files) => {
                                                try {
                                                    const file = files[files.length - 1];

                                                    new Compressor(file, {
                                                        mimeType: "image/png",
                                                        success: (result: any) => {
                                                            this.getBase64(result).then((res) => {
                                                                let updateState = {
                                                                    project: {
                                                                        ...project,
                                                                        sections: project.sections.map(
                                                                            (element: any, index: any) => {
                                                                                if (index === row.index)
                                                                                    return {
                                                                                        ...element,
                                                                                        sectionImage: {
                                                                                            file: result,
                                                                                            preview: res,
                                                                                        },
                                                                                    };
                                                                                return element;
                                                                            }
                                                                        ),
                                                                    },
                                                                    hasUnsavedFields: true,
                                                                };

                                                                this.setState(updateState);
                                                            });
                                                        },
                                                    });
                                                } catch (err) {
                                                    toast.warning(Strings.errors.notSupportedFile);
                                                }
                                            }}
                                        >
                                            <Icon name="pencil-outline" />
                                        </Dropzone>
                                        <div
                                            className={`ImageOverlayOption${
                                                Boolean(project.sections[row.id].sectionImage) ? "" : " __disabled"
                                            }`}
                                            onClick={() => {
                                                const deleteArray = [...this.state.filesToDelete];
                                                if (
                                                    project.sections[row.id].sectionImage &&
                                                    !project.sections[row.id].sectionImage.file
                                                )
                                                    deleteArray.push(project.sections[row.id].sectionImage);

                                                this.setState({
                                                    project: {
                                                        ...this.state.project,
                                                        sections: project.sections.map((element: any, index: any) => {
                                                            if (index === row.index)
                                                                return {
                                                                    ...element,
                                                                    sectionImage: null,
                                                                };
                                                            return element;
                                                        }),
                                                    },
                                                    filesToDelete: deleteArray,
                                                    hasUnsavedFields: true,
                                                });
                                            }}
                                        >
                                            <Icon name="trash" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={24} lg={16}>
                            <Row gutter={[24, 24]}>
                                <Col xs={24} lg={18}>
                                    <label className="SingleLabel __required">{Strings.projects.sectionName}</label>
                                    <Input
                                        placeholder={"Section Name"}
                                        defaultValue={
                                            project.sections[row.id].title
                                                ? project.sections[row.id].title[language]
                                                : ""
                                        }
                                        value={
                                            project.sections[row.id].title
                                                ? project.sections[row.id].title[language]
                                                : ""
                                        }
                                        onChange={(e) => {
                                            this.setState(
                                                {
                                                    project: {
                                                        ...project,
                                                        sections: project.sections.map((element: any, index: any) => {
                                                            if (index === row.index)
                                                                return {
                                                                    ...element,
                                                                    title: {
                                                                        ...element.title,
                                                                        [language]: e.target.value,
                                                                    },
                                                                };
                                                            return element;
                                                        }),
                                                    },
                                                    hasUnsavedFields: true,
                                                },
                                                () => {
                                                    row.toggleRowExpanded(true);
                                                }
                                            );
                                        }}
                                    />
                                </Col>
                                <Col xs={12} lg={6}>
                                    <label className="SingleLabel __required">{Strings.projects.order}</label>
                                    <InputNumber
                                        style={{ width: "100%" }}
                                        min={1}
                                        max={project.sections.length}
                                        defaultValue={row.id + 1}
                                        value={row.id + 1}
                                        onChange={(value: any) => {
                                            if (project.sections.length > 1) {
                                                this.array_move(project.sections, row.id, value - 1);
                                            }
                                            this.setState({
                                                project: {
                                                    ...project,
                                                    sections: project.sections.map((element: any, index: any) => {
                                                        if (index === row.index)
                                                            return {
                                                                ...element,
                                                                order: value - 1,
                                                            };

                                                        return element;
                                                    }),
                                                },
                                                hasUnsavedFields: true,
                                            });
                                        }}
                                    />
                                </Col>
                                <Col xs={24} lg={24}>
                                    <label className="SingleLabel __required">{Strings.projects.subtitle}</label>
                                    <Input
                                        placeholder={"Section Name"}
                                        defaultValue={
                                            project.sections[row.id].subtitle
                                                ? project.sections[row.id].subtitle[language]
                                                : ""
                                        }
                                        value={
                                            project.sections[row.id].subtitle
                                                ? project.sections[row.id].subtitle[language]
                                                : ""
                                        }
                                        onChange={(e) => {
                                            this.setState(
                                                {
                                                    project: {
                                                        ...project,
                                                        sections: project.sections.map((element: any, index: any) => {
                                                            if (index === row.index)
                                                                return {
                                                                    ...element,
                                                                    subtitle: {
                                                                        ...element.subtitle,
                                                                        [language]: e.target.value,
                                                                    },
                                                                };
                                                            return element;
                                                        }),
                                                    },
                                                    hasUnsavedFields: true,
                                                },
                                                () => {
                                                    row.toggleRowExpanded(true);
                                                }
                                            );
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row gutter={[24, 24]}>
                        <Col xs={24} lg={24}>
                            <label className="SingleLabel __required">{Strings.projects.sectionDescription}</label>
                            <Editor
                                extraData={language}
                                btnBlacklist={["source"]}
                                value={
                                    project.sections[row.id].description
                                        ? project.sections[row.id].description[language]
                                        : ""
                                }
                                onChange={(data: any) => {
                                    this.setState(
                                        {
                                            project: {
                                                ...project,
                                                sections: project.sections.map((element: any, index: any) => {
                                                    if (index === row.index)
                                                        return {
                                                            ...element,
                                                            description: {
                                                                ...element.description,
                                                                [language]: data,
                                                            },
                                                        };
                                                    return element;
                                                }),
                                            },
                                            hasUnsavedFields: true,
                                        },
                                        () => {
                                            row.toggleRowExpanded(true);
                                        }
                                    );
                                }}
                            />
                        </Col>
                    </Row>
                </ContentWrapper>
            </ContentWrapper>
        );
    }

    renderSections() {
        const { project, language } = this.state;
        return (
            <Table
                title={{
                    icon: "tarefa",
                    title: Strings.projects.sections || "",
                }}
                data={project.sections}
                columns={[
                    {
                        Header: Strings.projects.title,
                        id: "title",
                        accessor: (row: any) => (row.title ? row.title[language] : row.title),
                    },
                    {
                        Header: Strings.projects.order,
                        id: "order",
                        accessor: (row: any) => row.order,
                    },
                ]}
                expanded
                renderExpanded={(row: any) => this.renderSection(row)}
                add={{
                    label: String(Strings.formatString(Strings.generic.addNewM, "section")),
                    onClick: () => {
                        if (project.sections?.length > 0) {
                            const sectionsClone = [...project.sections];
                            const order = project.sections?.length + 1;
                            sectionsClone.push({
                                order: order,
                                title: { en: "Section " + order, pt: "Secção " + order },
                            });
                            this.setState({
                                project: {
                                    ...project,
                                    sections: sectionsClone,
                                },
                                hasUnsavedFields: true,
                            });
                        } else {
                            this.setState({
                                project: {
                                    ...project,
                                    sections: [
                                        {
                                            order: 1,
                                            title: { en: "Section 1", pt: "Secção 1" },
                                        },
                                    ],
                                },
                                hasUnsavedFields: true,
                            });
                        }
                    },
                }}
                actions={{
                    remove: (original, value) => ({
                        onClick: () => {
                            if (project.sections?.length > 0) {
                                const sectionsClone = [...project.sections].filter((element: any, index: any) => {
                                    if (index !== value.index) return element;
                                    return null;
                                });
                                this.setState({
                                    project: {
                                        ...project,
                                        sections: sectionsClone,
                                    },
                                    hasUnsavedFields: true,
                                });
                            }
                        },
                    }),
                }}
            />
        );
    }

    renderReview() {
        const { project, language } = this.state;
        return (
            <div>
                <ContentWrapper>
                    <Row gutter={[24, 24]}>
                        <Col xs={24} lg={6}>
                            <label className="SingleLabel __required">{Strings.projects.ownerImage}</label>
                            <div className="ImageContainer" style={{ maxHeight: "210px" }}>
                                <div className="Image">
                                    <img
                                        alt={Strings.fields.image}
                                        src={
                                            project.review.image !== null && typeof project.review.image === "object"
                                                ? project.review.image.preview
                                                : project.review.image && project.review.image !== "undefined"
                                                ? project.review.image
                                                : placeholder
                                        }
                                    />
                                    <div className="ImageOverlay">
                                        <Dropzone
                                            accept="image/jpg, image/jpeg, image/png"
                                            className="ImageOverlayOption"
                                            onDrop={(files) => this.onDrop(files, "ownerImage")}
                                        >
                                            <Icon name="pencil-outline" />
                                        </Dropzone>
                                        <div
                                            className={`ImageOverlayOption${
                                                Boolean(project.review.image) ? "" : " __disabled"
                                            }`}
                                            onClick={() => {
                                                const deleteArray = [...this.state.filesToDelete];
                                                if (project.review.image && !project.review.image.file)
                                                    deleteArray.push(project.review.image);

                                                this.setState({
                                                    project: {
                                                        ...project,
                                                        review: {
                                                            ...project.review,
                                                            image: null,
                                                        },
                                                    },
                                                    filesToDelete: deleteArray,
                                                    hasUnsavedFields: true,
                                                });
                                            }}
                                        >
                                            <Icon name="trash" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={24} lg={18}>
                            <Row>
                                <label className="SingleLabel __required">{Strings.projects.ownerName}</label>
                                <Input
                                    placeholder={Strings.projects.ownerName}
                                    defaultValue={project.review.name ? project.review.name : ""}
                                    value={project.review.name ? project.review.name : ""}
                                    onChange={(e) => {
                                        this.setState({
                                            project: {
                                                ...project,
                                                review: {
                                                    ...project.review,
                                                    name: e.target.value,
                                                },
                                            },
                                            hasUnsavedFields: true,
                                        });
                                    }}
                                />
                            </Row>
                            <Row>
                                <label className="SingleLabel __required">{Strings.projects.ownerPosition}</label>
                                <Input
                                    placeholder={Strings.projects.ownerPosition}
                                    defaultValue={project.review.position ? project.review.position[language] : ""}
                                    value={project.review.position ? project.review.position[language] : ""}
                                    onChange={(e) => {
                                        this.setState({
                                            project: {
                                                ...project,
                                                review: {
                                                    ...project.review,
                                                    position: {
                                                        ...project.review.position,
                                                        [language]: e.target.value,
                                                    },
                                                },
                                            },
                                            hasUnsavedFields: true,
                                        });
                                    }}
                                />
                            </Row>
                            <Row>
                                <div className={`GenericSwitch${project?.review?.published ? " __active" : ""}`}>
                                    <span>Published</span>
                                    <Switch
                                        className={`Switch ${project?.review?.published ? "__active" : ""}`}
                                        checked={project?.review?.published || false}
                                        size="small"
                                        onChange={(value: boolean) =>
                                            this.setState({
                                                project: {
                                                    ...project,
                                                    review: {
                                                        ...project.review,
                                                        published: value,
                                                    },
                                                },
                                                hasUnsavedFields: true,
                                            })
                                        }
                                    />
                                </div>
                            </Row>
                        </Col>
                    </Row>
                </ContentWrapper>
                <ContentWrapper>
                    <Row gutter={[24, 24]}>
                        <Col xs={24} lg={24}>
                            <label className="SingleLabel __required">{Strings.projects.review}</label>
                            <Input.TextArea
                                disabled={false}
                                placeholder={Strings.projects.review}
                                value={project?.review?.review?.[language]}
                                style={{ minHeight: "120px" }}
                                onChange={(e: any) =>
                                    this.setState({
                                        project: {
                                            ...project,
                                            review: {
                                                ...project.review,
                                                review: {
                                                    ...project.review.review,
                                                    [language]: e.target.value,
                                                },
                                            },
                                        },
                                        hasUnsavedFields: true,
                                    })
                                }
                            />
                        </Col>
                    </Row>
                </ContentWrapper>
            </div>
        );
    }

    renderTechs() {
        const { project, language } = this.state;
        return (
            <ContentWrapper>
                <Row gutter={[24, 24]}>
                    <Col xs={24} lg={24}>
                        <label className="SingleLabel __required">{Strings.projects.technologies}</label>
                        <Input
                            placeholder={Strings.projects.description}
                            defaultValue={
                                project.techSection?.description ? project.techSection?.description?.[language] : ""
                            }
                            value={project.techSection?.description ? project.techSection?.description?.[language] : ""}
                            onChange={(e) => {
                                this.setState({
                                    project: {
                                        ...project,
                                        techSection: {
                                            ...project.techSection,
                                            description: {
                                                ...project.techSection.description,
                                                [language]: e.target.value,
                                            },
                                        },
                                    },
                                    hasUnsavedFields: true,
                                });
                            }}
                        />
                    </Col>
                </Row>
                <div style={{ marginTop: "24px" }}>
                    <Table
                        title={{
                            icon: "tarefa",
                            title: Strings.projects.technologies || "",
                        }}
                        data={project.techSection.technologies}
                        columns={[
                            {
                                Header: Strings.projects.title,
                                id: "title",
                                accessor: (row: any) => (row.title ? row.title[language] : row.title),
                            },
                            {
                                Header: Strings.projects.order,
                                id: "order",
                                accessor: (row: any) => row.order,
                            },
                        ]}
                        expanded
                        renderExpanded={(row: any) => this.renderTechSection(row)}
                        add={{
                            label: String(Strings.formatString(Strings.generic.addNewM, "section")),
                            onClick: () => {
                                if (project.techSection?.technologies?.length > 0) {
                                    const sectionsClone = [...project.techSection.technologies];
                                    const order = project.techSection?.technologies?.length + 1;
                                    sectionsClone.push({
                                        order: order,
                                        title: { en: "Section " + order, pt: "Secção " + order },
                                    });
                                    this.setState({
                                        project: {
                                            ...project,
                                            techSection: {
                                                ...project.techSection,
                                                technologies: sectionsClone,
                                            },
                                        },
                                        hasUnsavedFields: true,
                                    });
                                } else {
                                    this.setState({
                                        project: {
                                            ...project,
                                            techSection: {
                                                ...project.techSection,
                                                technologies: [
                                                    {
                                                        order: 1,
                                                        title: { en: "Section 1", pt: "Secção 1" },
                                                    },
                                                ],
                                            },
                                        },
                                        hasUnsavedFields: true,
                                    });
                                }
                            },
                        }}
                        actions={{
                            remove: (original, value) => ({
                                onClick: () => {
                                    if (project.techSection?.technologies?.length > 0) {
                                        const sectionsClone = [...project.techSection.technologies].filter(
                                            (element: any, index: any) => {
                                                if (index !== value.index) return element;
                                                return null;
                                            }
                                        );
                                        this.setState({
                                            project: {
                                                ...project,
                                                techSection: {
                                                    ...project.techSection,
                                                    technologies: sectionsClone,
                                                },
                                            },
                                            hasUnsavedFields: true,
                                        });
                                    }
                                },
                            }),
                        }}
                    />
                </div>
            </ContentWrapper>
        );
    }

    renderNumbers() {
        const { project, language } = this.state;
        return (
            <Table
                title={{
                    icon: "tarefa",
                    title: Strings.projects.numbers || "",
                }}
                data={project.numbersSections}
                columns={[
                    {
                        Header: Strings.projects.title,
                        id: "title",
                        accessor: (row: any) => (row.title ? row.title[language] : row.title),
                    },
                    {
                        Header: Strings.projects.order,
                        id: "order",
                        accessor: (row: any) => row.order,
                    },
                ]}
                expanded
                renderExpanded={(row: any) => this.renderNumberSection(row)}
                add={{
                    label: String(Strings.formatString(Strings.generic.addNewM, "section")),
                    onClick: () => {
                        if (project.numbersSections?.length > 0) {
                            const sectionsClone = [...project.numbersSections];
                            const order = project.numbersSections?.length + 1;
                            sectionsClone.push({
                                order: order,
                                title: { en: "Section " + order, pt: "Secção " + order },
                            });
                            this.setState({
                                project: {
                                    ...project,
                                    numbersSections: sectionsClone,
                                },
                                hasUnsavedFields: true,
                            });
                        } else {
                            this.setState({
                                project: {
                                    ...project,
                                    numbersSections: [
                                        {
                                            order: 1,
                                            title: { en: "Section 1", pt: "Secção 1" },
                                        },
                                    ],
                                },
                                hasUnsavedFields: true,
                            });
                        }
                    },
                }}
                actions={{
                    remove: (original, value) => ({
                        onClick: () => {
                            if (project.numbersSections?.length > 0) {
                                const sectionsClone = [...project.numbersSections].filter(
                                    (element: any, index: any) => {
                                        if (index !== value.index) return element;
                                        return null;
                                    }
                                );
                                this.setState({
                                    project: {
                                        ...project,
                                        numbersSections: sectionsClone,
                                    },
                                    hasUnsavedFields: true,
                                });
                            }
                        },
                    }),
                }}
            />
        );
    }

    render() {
        const { selectedTab } = this.state;
        const tabs = [
            {
                key: "general",
                title: Strings.projects.general,
                onClick: () => this.setState({ selectedTab: "general" }),
                renderScreen: () => this.renderGeneral(),
            },
            {
                key: "numbers",
                title: Strings.projects.numbers,
                onClick: () => this.setState({ selectedTab: "numbers" }),
                renderScreen: () => this.renderNumbers(),
            },
            {
                key: "sections",
                title: Strings.projects.sections,
                onClick: () => this.setState({ selectedTab: "sections" }),
                renderScreen: () => this.renderSections(),
            },
            {
                key: "techs",
                title: Strings.projects.technologies,
                onClick: () => this.setState({ selectedTab: "techs" }),
                renderScreen: () => this.renderTechs(),
            },
            {
                key: "review",
                title: Strings.projects.review,
                onClick: () => this.setState({ selectedTab: "review" }),
                renderScreen: () => this.renderReview(),
            },
        ];

        return (
            <React.Fragment>
                <Helmet>
                    <title>{Strings.projects.project}</title>
                    <meta name="description" content="Description of ProjectDetail" />
                </Helmet>
                <SelectableTabs selectedTab={selectedTab} tabs={tabs}></SelectableTabs>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: any) => ({});

export default connect(mapStateToProps)(ProjectDetail);
